export default "__VITE_ASSET__Ci3R6oWF__"